(ns pfo.category.model
  (:require [pfo.api :as api]
            [pfo.util :as util]
            [pfo.auth.model :as auth-model]
            [pfo.scope.scope :as scope]))

(def category-view-permissions
  [:can_view_document
   :can_view_event
   :can_view_compliance
   :can_view_task])

(defn categories-view-permitted [family-id]
  (some (fn [perm] (auth-model/has-family-perm family-id perm)) category-view-permissions))

(defn categories-view-any-permitted []
  (some (fn [perm] (auth-model/has-perm-in-any-family perm)) category-view-permissions))

(defn category-key [category]
  (str "category-" (:id category)))

(defn category-list
  ([scope category-type order count]
   (api/ajaxp "/categories/"
     {:params (util/remove-nil-values
                (merge
                  {:type  category-type
                   :active true}
                  (case (:level scope)
                    :family {:group (:id scope)}
                    :subscriber {:subscriber (:id scope)}
                    nil)
                  (when count {:count_objects count})))}))
  ([group-id category-type] (category-list group-id category-type "name" false)))

(defn category-admin-list [subscriber-id group-id active]
  (api/ajaxp "/categories/"
             {:params (util/remove-nil-values
                       (merge
                        {:group      group-id
                         :subscriber subscriber-id}
                        (when (some? active) {:active active})))}))

(defn category-update [scope id form-data]
  (api/ajaxp
    (str "/category/" id "/")
    {:method :post
     :body (util/make-params
             (util/remove-nil-values
               (assoc form-data
                 :operation_scope (scope/to-str scope))))}))

(defn category-add [scope form-data]
  (api/ajaxp
    (str "/category/")
    {:method :post
     :body (util/make-params
             (util/remove-nil-values
               (assoc form-data
                 :operation_scope (scope/to-str scope))))}))

(defn category-delete [scope id]
  (api/ajaxp
    (str "/category/" id "/?"
      (util/make-params
        (util/remove-nil-values
          {:operation_scope (scope/to-str scope)})))
    {:method :delete
     :response :raw}))
